import { Playout } from './../interfaces/playout';
import { PublicationService } from './publication.service';
import { Injectable } from '@angular/core';

@Injectable()
export class PlayoutService {
	public skinGeneration: number;
	public initialSkin: any;
	playout: Playout;
	pubSkinGeneration: string;
	currentSkinGeneration = 8;

	constructor(
		private publicationSerice: PublicationService
	) {
		this.fetchSkinGeneration();
	}

	setPlayout(playout: Playout) {
		this.playout = playout;
		this.checkHoverSettings();
		this.updateSkinGeneration();
	}

	checkHoverSettings() {
		if (this.playout?.linkPauseHoverStates !== 'false') {
			// for the g8 skin these settings were added but the defaults need to be the same as the pause screen as long as they are untouched
			this.playout.showBigHoverButtons = this.playout.showBigPauseButtons;
			this.playout.titleHover = this.playout.titlePause;
			this.playout.authorCopyrightHover = this.playout.authorCopyrightPause;
		}
	}

	updateSkinGeneration() {
		this.skinGeneration = this.parseSkinGeneration(this.playout?.skinGeneration || this.pubSkinGeneration || ('g' + this.currentSkinGeneration));
	}

	fetchSkinGeneration() {
		this.publicationSerice.getData().subscribe((pub) => {
			this.pubSkinGeneration = pub?.skinGeneration;
			this.updateSkinGeneration();
		});
	}

	private parseSkinGeneration(skinGeneration: string) {
		if (!skinGeneration) {
			return null;
		}
		const gen = parseFloat(skinGeneration.substring(1));
		if (typeof gen !== 'number') {
			return null;
		}
		return gen;
	}
}
